import { createContext, useContext } from 'react'
import { type Theme } from '#app/utils/theme.server'

type ThemeContext = {
	themePreference: Theme
}

export const ThemeContext = createContext<Partial<ThemeContext>>({})

export const ThemeProvider = ThemeContext.Provider

export const useTheme = () => {
	const context = useContext(ThemeContext)

	if (context === undefined) {
		throw new Error('useTheme must be used within a ThemeProvider')
	}

	return context as ThemeContext
}
